import type { GraphFileItem } from "@/api/models"

import { downloadGraphFileApi } from "@/api/api"
import { SettingsService } from "@/services/settings-service"

export const STUDIO_AI_IMAGE_ACCEPT: Record<string, string[]> = {
  "image/*": [".png", ".jpg", ".jpeg"],
}

export const STUDIO_AI_IMAGE_MAX_SIZE_BYTES = 50 * 1024 * 1024

export function isSupportedStudioAiImage(file: Pick<File, "type" | "name">): boolean {
  const isValidMime = /^image\/(png|jpeg|jpg)$/i.test(file.type)
  const extension = file.name.toLowerCase().match(/\.[^.]+$/)?.[0] ?? ""
  const isValidExtension = [".png", ".jpg", ".jpeg"].includes(extension)
  return isValidMime || isValidExtension
}

export async function graphItemToImageFile(item: GraphFileItem): Promise<File> {
  const token = SettingsService.getInstance().token
  const blob = await downloadGraphFileApi(item, token)
  const mime = item.mimeType || blob.type || "application/octet-stream"
  return new File([blob], item.name, { type: mime })
}
